import React, { useEffect, useCallback, useState, useRef } from 'react';
import zohoService from '../../../services/zohoService';
import ZohoForm from '../../../components/pageModule/Zoho/ZohoForm';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';

const DATA_CENTER_OPTIONS = [
    { id: 'US', label: 'United States (US)' },
    { id: 'EU', label: 'Europe (EU)' },
    { id: 'IN', label: 'India (IN)' },
    { id: 'AU', label: 'Australia (AU)' },
    { id: 'SA', label: 'Saudi Arabia (SA)' },
];

const defaultInitialData = {
    zoho_client_id: '',
    zoho_client_secret: '',
    zoho_redirect_uri: '',
    zoho_data_center: 'IN',
    zoho_status: {
        id: '1',
        label: 'Active',
    },
    zoho_tenant: null,
    access_token: '',
    refresh_token: '',
    expires: '',
    is_connected: false,
    supplier_tag: null,
    walkin_customer_tag: null,
    lpo_customer_tag: null,
};

const ZohoSettings = () => {
    const [initialData, setInitialData] = useState(defaultInitialData);
    const isFetching = useRef(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleCreate = async (formData) => {
        try {
            const response = await zohoService.saveSettings(formData);
            toast.success('Zoho settings saved successfully', {
                position: "top-right",
                autoClose: 500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true
            });
            return response;
        } catch (error) {
            toast.error(error.message || 'Error saving Zoho settings', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            throw error;
        }
    };

    const actions = {
        create: handleCreate,
    };

    const fetchData = useCallback(async () => {
        if (isFetching.current) {
            return;
        }
        isFetching.current = true;

        try {
            setIsLoading(true);
            const data = await zohoService.getSettings();
            setInitialData({
                ...defaultInitialData,
                ...data,
                zoho_client_id: data.zoho_client_id || data.client_id || '',
                zoho_data_center: data.zoho_data_center || 'IN',
                zoho_status: data.zoho_status || defaultInitialData.zoho_status,
            });
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            isFetching.current = false;
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);
    
    return (
        <div className="row">
            <div className="col-lg-12">
                <ZohoForm
                    initialData={initialData}
                    dataCenterOptions={DATA_CENTER_OPTIONS}
                    onSave={async (data) => {
                        try {
                            const response = await actions.create(data);
                            await fetchData();
                            return response;
                        } catch (error) {
                            console.error('Error saving Zoho settings:', error);
                            throw error;
                        }
                    }}
                    onRefresh={fetchData}
                    isLoading={isLoading}
                />
            </div>
        </div>
    );
};

export default ZohoSettings;
